import React, { useEffect, useState, useContext } from "react";
import { Card, Form, CardBody, CardSubtitle, Container, Progress } from "reactstrap"
import Dropzone from "react-dropzone";
import ModalContext from "contexts/ModalContext";
import helper from "services/helper";
import { UploadFile } from "services/Api/Module/Broadcast";

const UploadFileS3 = ({
  label = "Dropzone",
  description = "description",
  onChange = () => console.log('onChange!'),
  prefixName = "broadcast",
  value = null,
  upload = "Image",
  typeUpload = ""
}) => {
  // POPUP
  const { mAlert } = useContext(ModalContext);

  const [firstLoad, setFirstLoad] = useState(false);
  const [fileData, setFileData] = useState(null);
  const [fileURL, setFileURL] = useState(null);
  const [imageSize, setImageSize] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

  async function handleAcceptedFiles(files) {
    console.log("🚀 ~ handleAcceptedFiles ~ files:", files)
    const _fileData = files[0]
    const tmpfilename = _fileData?.name ?? '.png'
    const typeSplit = `${tmpfilename}`.split('.')
    const typeFile = typeSplit[typeSplit.length - 1]

    const fileSize = _fileData.size
    const sizeInMB = fileSize / 1024 / 1024; // Convert bytes to MB

    let updateImageSize = '0x0'

    let CONF_FILE_TYPE = ['png','jpg','jpeg']
    let CONF_FILE_SIZE = 10
    let JOIN = ', '
    // upload = "Image"
    if (upload == "Video") {
      CONF_FILE_TYPE = ['mp4']
      CONF_FILE_SIZE = 50
      JOIN = ''
    }

    const typeFileLower = typeFile.toLowerCase()
    if (CONF_FILE_TYPE.includes(typeFileLower)) {
      // เฉพาะ Image เท่านั้นที่ต้องเช็ค dimensions
      if (upload === "Image") {
        const { width, height } = await helper.FNFILE.getImageDimensions(_fileData)
        updateImageSize = `${width}x${height}`

        if (typeUpload == "ImageMap") {
          let minSize = 1024;
          console.log("🚀 ~ handleAcceptedFiles ~ width, height:", width, height)
          console.log("🚀 ~ handleAcceptedFiles ~ 1", width >= minSize)
          console.log("🚀 ~ handleAcceptedFiles ~ 2", height >= minSize)
          console.log("🚀 ~ handleAcceptedFiles ~ 3", width == height)
          if (!(width >= minSize && height >= minSize)) {
            mAlert.info({
              title: "Alert",
              subTitle: `File resolution min ${minSize}px and ratio 1:1 4:3 3:4`,
              content: "",
              onClose: () => {
              },
            })
            return
          }
        }
      }

      if (sizeInMB <= CONF_FILE_SIZE) {
        setFileURL(URL.createObjectURL(files[0]))
        setFileData(files[0])
        setImageSize(updateImageSize)
      } else {
        mAlert.info({
          title: "Alert",
          subTitle: `File size max ${CONF_FILE_SIZE} MB`,
          content: "",
          onClose: () => {
          },
        })
      }
    } else {
      mAlert.info({
        title: "Alert",
        subTitle: `File type ${CONF_FILE_TYPE.join(JOIN)} only`,
        content: "",
        onClose: () => {
        },
      })
    }
    

    // formatBytes(file.size)
    // เซ็ตไว้ดูก่อน

    // files.map(file =>
    //   Object.assign(file, {
    //     preview: URL.createObjectURL(file),
    //     formattedSize: formatBytes(file.size),
    //   })
    // )
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  const uploadFile = async (_fileData = {}) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      console.log("🚀 ~ uploadFile ~ _fileData:", _fileData);

      const response = await UploadFile({
        file: _fileData,
        onProgress: (percent) => {
          console.log("Uploading " + percent + "%");
          setUploadProgress(percent);
        },
      });

      console.log("🚀 ~ uploadFile ~ response:", response);

      const resData = response.data;
      
      // ตรวจสอบ response: resultCode 20201 = Create Data Success
      if (resData && resData.resultCode === 20201) {
        const FILE_LINK = resData.resultData;
        
        console.log("🚀 ~ uploadFile ~ [FILE_LINK, imageSize]:", [FILE_LINK, imageSize]);
        onChange([FILE_LINK, imageSize]);
      } else {
        throw new Error(resData?.resultDescription || "Upload failed");
      }
    } catch (err) {
      console.log("🚀 ~ uploadFile ~ err:", err);
      mAlert.info({
        title: "Alert",
        subTitle: err?.response?.data?.resultDescription || err?.message || "Something went wrong",
        content: "",
        onClose: () => {},
      });
      onClearState();
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const onClearState = () => {
    setFileData(null)
    setFileURL(null)
    setFirstLoad(false)
    setUploadProgress(0)
    setIsUploading(false)
    onChange(["", null])
  }

  useEffect(() => {
    if (fileData) {
      uploadFile(fileData)
    }
  }, [fileData])

  useEffect(() => {
    console.log("🚀 ~ useEffect ~ value:", value)
    if (value) {
      setFileURL(value)
      setFirstLoad(true)
    } else {
      onClearState()
    }
  }, [value])


  let acceptFile = { 'image/*': ['.png','jpg','.jpeg'] }
  description = 'File type png, jpg, jpeg only, Max filesize 10 MB '
  if (upload == "Video") {
    acceptFile = { 'video/*': ['.mp4'] }
    description = 'File type mp4 only, Max file size 50 MB'
  }
  if (typeUpload == "ImageMap") {  
    description = 'File type png, jpg, jpeg only, Max filesize 10 MB, File resolution min 1024px and ratio 1:1 4:3 3:4'
  }

  return (
    <React.Fragment>
      <Card>
        <div>
          <h6 className="card-title">{label}</h6>
          <CardSubtitle className="mb-3">
            {description}
          </CardSubtitle>
          <Form>
              {
                isUploading ? (
                  <div className="dropzone d-flex flex-column align-items-center justify-content-center">
                    <div className="w-75">
                      <Progress value={uploadProgress} className="mb-2" />
                      <p className="text-center">Uploading... {uploadProgress}%</p>
                    </div>
                  </div>
                ) : fileData || firstLoad ? (
                  <>
                      {
                        upload === "Image" ? (
                          <div className="dropzone bImageBox">
                            <img
                              data-dz-thumbnail=""
                              src={fileURL}
                              alt="uploaded"
                            />
                          </div>
                        )
                        : 
                        upload === "Video" ? (
                          <div className="dropzone bImageBox" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px' }}>
                            <video
                              src={fileURL}
                              controls
                              style={{ width: '100%', maxHeight: '400px', objectFit: 'contain' }}
                            />
                          </div>
                        )
                        : <>NULL</>

                      }
                    <div className="mt-4">
                        <button
                          type="button"
                          className="btn btn-danger "
                          onClick={onClearState}
                        >
                          Delete
                        </button>
                      </div>
                  </>
                ) : (
                  <Dropzone
                    onDrop={acceptedFiles => {

                      handleAcceptedFiles(acceptedFiles)
                    }}
                    // accept= {{
                    //   'image/*': ['.png','jpg','.jpeg']
                    // }}
                    accept= {acceptFile}
                    multiple={false}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div className="dropzone">
                        <div
                          className="dz-message needsclick mt-2"
                          {...getRootProps()}
                        >
                          <input {...getInputProps()} />
                          <div className="mb-3">
                            <i className="display-4 text-muted bx bxs-cloud-upload" />
                          </div>
                          <h4>Drop {upload} file here or click to upload.</h4>
                        </div>
                      </div>
                    )}
                  </Dropzone>
                )
              }
          </Form>

          {/* <div className="mt-4">
            <button
              type="button"
              className="btn btn-primary "
              onClick={() => uploadFile(fileData)}
            >
              Upload
            </button>
          </div> */}

         

        </div>
      </Card>
    </React.Fragment>
  )
}

export default UploadFileS3
